import React from "react";
import { Route, Routes } from "react-router-dom";
import PublicLayout from "../Routes/public-layout";
import configureRoutes from "./routes";
import ErrorLayout from "./ErrorLayout";

const MainRoutes = () => {
  const routes = configureRoutes();

  return (
    <Routes>
      {routes.map((route) => {
        if (route.type === "public") {
          return (
            <Route
              key={route.path}
              path={route.path}
              element={<PublicLayout {...route} />}
            />
          );
        }

        if (route.type === "error") {
          return (
            <Route
              key={route.path}
              path={route.path}
              element={<ErrorLayout {...route} />}
            />
          );
        }

        return null;
      })}
    </Routes>
  );
};

export default MainRoutes;